import { render, staticRenderFns } from "./SveiMappa.vue?vue&type=template&id=42077f75"
import script from "./SveiMappa.vue?vue&type=script&lang=js"
export * from "./SveiMappa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports